const Address = (val) => {
    let valid = false;
    let error = null;

    if (typeof val !== 'object' || Array.isArray(val) || val === null) {
        valid = false;
        error = 'Please enter a complete address';
    } else {
        valid = !!val.streetName && !!val.streetNumber && !!val.town && !!val.country;
        error = 'Please enter a complete address';
    }

    if (val.postcode) {
        const regex = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]?([0-9][A-Z]{2})?$/i;
        if (regex.test(val.postcode.replace(' ', '').toLowerCase()) === false) {
            valid = false;
            error = 'Please enter a valid postcode';
        }
    }

    return [
        valid,
        error,
    ]
}

export default Address;